import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App.jsx";
import ErrorBoundary from "./components/ErrorBoundary.jsx";
import { initGA, initWebVitals, trackPerformance } from "./utils/analytics";
import "./utils/performanceMonitor"; // Auto-initializes in dev mode

// Redirect from Netlify URL to primary domain
if (window.location.hostname === "k3yur.netlify.app") {
  window.location.replace(
    `https://k3yur.in${window.location.pathname}${window.location.search}${window.location.hash}`
  );
}

createRoot(document.getElementById("root")).render(
  <ErrorBoundary>
    <BrowserRouter>
      <StrictMode>
        <App />
      </StrictMode>
    </BrowserRouter>
  </ErrorBoundary>
);

// Initialize analytics and monitoring
if (!import.meta.env.DEV) {
  initGA();
}
initWebVitals();
trackPerformance();

// Register service worker for PWA functionality
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        console.log("SW registered: ", registration);
      })
      .catch((registrationError) => {
        console.log("SW registration failed: ", registrationError);
      });
  });
}
